export default __webpack_public_path__ + "static/media/Darkblade's Gloves of Consumed Souls.7bd5c238.jpg";